const toggleData = (param, backRef) => {
  var chartSeries = backRef.chart.series;
  chartSeries.forEach(obj => {
    if (param === "false") {
      obj.show();
    } else {
      obj.hide();
    }
  });
};

const from = dateFrom => {
  if (typeof dateFrom === "object") {
    dateFrom = dateFrom.toISOString().split("T")[0];
    return dateFrom;
  }
  return dateFrom;
};
const to = dateTo => {
  if (typeof dateTo === "object") {
    dateTo = dateTo.toISOString().split("T")[0];
    return dateTo;
  }
  return dateTo;
};

const isCurrentUser = (...users) => {
  let storedUser = localStorage.getItem("full_name");
  let confirmedUser = false;
  for (let user of users) {
    if (storedUser === user) {
      confirmedUser = true;
    }
  }
  return confirmedUser;
};

const isUserLoggedIn = router => {
  if (!localStorage.getItem("arr_user")) {
    router.push("/pages/login/");
  }
};

const downloadExcel = (http, parameters, setLoading, downloadUrl, fileName) => {
  setLoading(true);
  let params = { ...parameters, xml: "true" };
  http
    .get(downloadUrl, {
      params,
      responseType: "blob"
    })
    .then(
      res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName + ".xlsx");
        document.body.appendChild(link);
        link.click();
        setLoading(false);
      },
      err => {
        setLoading(false);

        console.log(err);
      }
    );
};

export { toggleData, from, to, isCurrentUser, isUserLoggedIn, downloadExcel };
